import { render, staticRenderFns } from "./textareaComp.vue?vue&type=template&id=15893922&scoped=true"
import script from "./textareaComp.vue?vue&type=script&lang=js"
export * from "./textareaComp.vue?vue&type=script&lang=js"
import style0 from "./textareaComp.vue?vue&type=style&index=0&id=15893922&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15893922",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15893922')) {
      api.createRecord('15893922', component.options)
    } else {
      api.reload('15893922', component.options)
    }
    module.hot.accept("./textareaComp.vue?vue&type=template&id=15893922&scoped=true", function () {
      api.rerender('15893922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/textareaComp.vue"
export default component.exports